import React from 'react';

export default function Solutions() {
  return <div>Solutions page</div>;
}
